import Layout from '../../components/feature/Layout';
import AcreditacionDocumental from '../home/components/AcreditacionDocumental';
import SEO from '../../components/feature/SEO';

const gestionJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Gestión Documental HSE',
  provider: {
    '@type': 'Organization',
    name: 'SafeLine Solutions',
    url: `${import.meta.env.VITE_SITE_URL ?? ''}`,
  },
  url: `${import.meta.env.VITE_SITE_URL ?? ''}/gestion-documental`,
  description: 'Servicio de gestión y acreditación documental HSE. Organizamos y gestionamos toda la documentación de seguridad de tu empresa con eficiencia y cumplimiento normativo.',
  areaServed: {
    '@type': 'Place',
    name: 'Latinoamérica',
  },
  serviceType: 'Gestión Documental y Acreditación HSE',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: `${import.meta.env.VITE_SITE_URL ?? ''}/` },
      { '@type': 'ListItem', position: 2, name: 'Servicios', item: `${import.meta.env.VITE_SITE_URL ?? ''}/servicios` },
      { '@type': 'ListItem', position: 3, name: 'Gestión Documental', item: `${import.meta.env.VITE_SITE_URL ?? ''}/gestion-documental` },
    ],
  },
};

export default function GestionDocumentalPage() {
  return (
    <Layout>
      <SEO
        title="Gestión Documental HSE | SafeLine Solutions"
        description="Servicio de gestión y acreditación documental HSE. Organizamos y gestionamos toda la documentación de seguridad de tu empresa con eficiencia y cumplimiento normativo en Latinoamérica."
        keywords="gestión documental HSE, acreditación documental, documentación seguridad, cumplimiento normativo HSE"
        canonical="/gestion-documental"
        jsonLd={gestionJsonLd}
      />
      <div className="pt-20">
        <AcreditacionDocumental />
      </div>
    </Layout>
  );
}
